import { Col, Row } from "antd";
import React, { useState } from "react";

import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";

import "./CollapseContainer.css";

function CollpaseContainer({ children, title, extras }) {
  const [collapse, setCollapse] = useState(true);
  return (
    <Row className="collapse">
      <Col span={24} className="header">
        <Row justify="space-between">
            <Col>
            <Row align="stretch" gutter={[8, 0]} onClick={() => setCollapse(!collapse)}>
          <Col>
            {collapse ? (
              <RiArrowUpSLine size={18} />
            ) : (
              <RiArrowDownSLine size={18} />
            )}
          </Col>
          <Col>
            <span>{title}</span>
          </Col>
        </Row>
            </Col>
            <Col >
            {extras}
            </Col>
        </Row>
      </Col>
      {collapse ? (
        <Col span={24} className="content">
          {children}
        </Col>
      ) : null}
    </Row>
  );
}

export default CollpaseContainer;
